
import { Button, Flex } from '@chakra-ui/react';
import { useState } from 'react';

import Dialog from '@app/components/common/modals/dialog';
import { TextField, Txt } from '@app/components/common';
import { useAlert } from '@app/hooks';

export const CancelDialog = ({ open, onAction, onCancel }: {
  open: boolean;
  onAction(comment?: string): void;
  onCancel(): void;
}) => {
  const [comment, setComment] = useState('');
  const alert = useAlert();
  return <Dialog
    open={open}
    title="Отменить"
    onClose={onCancel}
    actions={[
        <Button variant='solid' colorScheme='red' key='cancel' onClick={() => {
          if (!comment || comment.length === 0) {
            alert.error('Пожалуйста, введите причину отмены');
            return;
          }
          onAction(comment);
          onCancel();
        }}
        >Подтвердить</Button>
      ]}
  >
      <Flex direction='column' gap={4}>
        <Txt>Отменить создание мастер ТТ?</Txt>
        <TextField multiline value={comment} label='Причина' onChange={setComment} id='comment'/>
      </Flex>
    </Dialog>;
};